import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface PriceProps {
  zoom: number;
  isSelected: boolean;
}

export const Price = styled.div<PriceProps>`
  position: relative;
  width: fit-content;
  padding: 4px;
  border-radius: 8px;
  background-color: ${({ isSelected }) => (isSelected ? ColorPalette.HEX.BrightOrange : ColorPalette.HEX.White)};
  color: ${({ isSelected }) => (isSelected ? ColorPalette.HEX.White : ColorPalette.HEX.OuterSpace5)};
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  transform: ${({ zoom }) => {
    let cssZoom = (zoom - 10) * 0.1 + 0.5;
    if (cssZoom < 0.5) cssZoom = 0.5;
    if (cssZoom > 1) cssZoom = 1;
    return `translateX(-50%) translateY(calc(-100% - 8px)) scale(${cssZoom})`;
  }};
  box-shadow: 0px 5px 13px 0px ${ColorPalette.HEX.Black};

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 10px solid ${ColorPalette.Transparent};
    border-top-color: ${({ isSelected }) => (isSelected ? ColorPalette.HEX.BrightOrange : ColorPalette.HEX.White)};
    border-bottom: 0;
    margin-left: -10px;
    margin-bottom: -9px;
  }
`;
